import React from 'react';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const Careers = () => {
  return (
    <div className="min-h-screen bg-softwhite">
      <div className="pt-32 pb-16 px-4 max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-8">Join Our Team</h1>
        <p className="text-xl mb-12">Be part of a dynamic team making a difference in the business world. Explore our current openings below.</p>
        
        <div className="mb-16">
          <h2 className="text-2xl font-bold mb-6">Why Work With Us</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-xl font-bold mb-3">Innovation</h3>
              <p>Work on cutting-edge solutions that push the boundaries of what's possible in business strategy and AI.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-xl font-bold mb-3">Growth</h3>
              <p>Continuous learning opportunities and clear career paths to help you develop professionally.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-xl font-bold mb-3">Impact</h3>
              <p>See the direct impact of your work as you help businesses transform and succeed.</p>
            </div>
          </div>
        </div>
        
        <div>
          <h2 className="text-2xl font-bold mb-6">Open Positions</h2>
          <div className="space-y-6">
            <div className="border border-gray-200 rounded-xl p-6 bg-white">
              <h3 className="text-xl font-bold mb-2">AI Solutions Architect</h3>
              <p className="text-goldcore mb-4">Full-time · Remote</p>
              <p className="mb-4">Design and implement AI-powered solutions for our clients, working with a team of experts to deliver exceptional results.</p>
              <Button variant="gold" asChild>
                <Link to="/chat">Ask KnightAI</Link>
              </Button>
            </div>
            <div className="border border-gray-200 rounded-xl p-6 bg-white">
              <h3 className="text-xl font-bold mb-2">Business Strategy Consultant</h3>
              <p className="text-goldcore mb-4">Full-time · New York</p>
              <p className="mb-4">Help our clients develop and execute effective business strategies that drive growth and success in competitive markets.</p>
              <Button variant="gold">Apply Now</Button>
            </div>
            <div className="border border-gray-200 rounded-xl p-6 bg-white">
              <h3 className="text-xl font-bold mb-2">Marketing Specialist</h3>
              <p className="text-goldcore mb-4">Full-time · Chicago</p>
              <p className="mb-4">Create and execute marketing strategies that showcase our services and help us connect with businesses that can benefit from our expertise.</p>
              <Button variant="gold">Apply Now</Button>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Careers;
